import styled from 'styled-components'

export const DoctorViewContainer = styled.div`
  display: flex;
  margin: 20px;
  flex-direction: column;
  @media (max-width: 1200px) {
    flex-direction: column;
    margin-top: 130px;
    margin-bottom: 20px;
    gap:15px;
  }
`
export const TabEmptyText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  font-weight: 600;
`
